export default class PassengerGroupPassenger {
    id: number;
    name: string;
    passengerGroupId: number;
    passengerId: number;

    constructor(passengerGroupPassenger: any) {
        this.id = passengerGroupPassenger.id;
        this.name = passengerGroupPassenger.passenger.name;
        this.passengerGroupId = passengerGroupPassenger.id;
        this.passengerId = passengerGroupPassenger.passenger.id
    }
}
